<template>
<div>
  <v-layout v-if="loading" row justify-center>
    <v-flex class="text-xs-center py-5 my-5" xs12>
      <v-progress-circular color="accent" indeterminate></v-progress-circular>
    </v-flex>
  </v-layout>
  <v-layout v-else class="pt-3" row wrap justify-center>
    <v-flex xs12 md10>
      <v-card @copy.prevent="" class="px-2 mx-2 py-2 elevation-0">
        <div class="display-1 text-xs-center"><b>{{taskData.name}}</b></div>
        <v-divider class="my-3"></v-divider>
        <div @keydown="disableCopy($event)" tabindex="0" class="quill-unit pb-4" v-html="taskData.text"></div>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    contentProgress: {},
    taskData: null
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.currentProgress = this.$store.getters.currentProgress
      this.taskData = this.$store.getters.taskByKey(this.currentProgress.task)
      if (this.taskData.type === 'Linking') this.taskData = this.$store.getters.taskByKey(this.taskData.linkedTaskKey)
      this.loading = false
      this.saveProgress()
    },
    saveProgress () {
      let taskProgress = this.$store.getters.taskProgressByTaskByProgress(this.currentProgress.task, this.currentProgress.progress)
      if (!taskProgress) {
        const newTaskProgress = {
          taskKey: this.currentProgress.task,
          progressKey: this.currentProgress.progress,
          studentId: this.$store.getters.user.uid,
          startTime: this.$store.getters.now,
          complete: true
        }
        this.$store.dispatch('createTaskProgress', newTaskProgress).catch(err => {
          const appMsg = {
            type: 'error',
            msg: err.message
          }
          this.$store.dispatch('showAppMsg', appMsg)
        })
      }
    },
    disableCopy (event) {
      if (event.key === 'c' && event.ctrlKey) event.preventDefault()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myCourses/ReadingTask.vue